import React from 'react';
import styled from 'styled-components';
import { HeadlineOne, Paragraph } from 'components/atoms/SectionWrapper.style';

const OptimalizationWrapper = styled.div`
  margin-top: 80px;
  text-align: center;
  margin: 0 auto;

  @media ${({ theme }) => theme.media.tablet} {
    width: 75%;
  }
`;

const OptimalizationEnergy = () => (
  <>
    <OptimalizationWrapper>
      <HeadlineOne>Na czym polega optymalizacja energii?</HeadlineOne>
      <Paragraph>
        Uważasz że zużycie prądu w Twojej firmie jest zbyt wysokie? Chciałbyś to
        zmienić, ale nie wiesz od czego zacząć? Skorzystaj z pomocy
        profesjonalistów w tej dziedzinie. Świadczymy kompleksowe usługi w
        zakresie optymalizacji kosztów energii. W Twojej firmie może być wiele
        przyczyn nadmiernego zużycia prądu. Znajdziemy je, zweryfikujemy,
        opiszemy i przedstawimy możliwe rozwiązania problemu. Efektywny audyt
        energetyczny to pierwszy krok do zmniejszenia zużycia prądu i większych
        oszczędności.
      </Paragraph>
    </OptimalizationWrapper>
  </>
);

export default OptimalizationEnergy;
